<template>
  <div class="h-screen w-screen flex justify-center items-center flex-col p-4">
    <h1 class="text-xl font-bold mb-4">Network error</h1>
    <div class="text-red-500 text-sm mb-2">Message: {{ error?.message || 'No message' }}</div>
    <div class="text-gray-500 text-xs mb-2">Status: {{ error?.statusCode || 'N/A' }}</div>
    <div class="text-blue-500 text-xs mb-2">Status Message: {{ error?.statusMessage || 'N/A' }}</div>
    <div class="text-green-500 text-xs mb-4">Description: {{ (error as any)?.description || 'N/A' }}</div>
    <div class="text-xs text-gray-400 mb-2">Full error object:</div>
    <pre class="text-xs w-full max-w-2xl overflow-auto bg-gray-100 p-4 rounded text-left">{{ errorJson }}</pre>
  </div>
</template>

<script setup lang="ts">
import type { NuxtError } from "#app";
const props = defineProps<{
  error: NuxtError;
}>();

const errorJson = computed(() => {
  try {
    return JSON.stringify(props.error, Object.getOwnPropertyNames(props.error), 2);
  } catch (e) {
    return String(props.error);
  }
});

console.log('Error details:', props.error);
</script>

<style scoped lang="scss"></style>
